module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _c('a', {
    attrs: {
      "href": "#/SustainableBadass4#_idTextAnchor128"
    }
  }, [_vm._v("Foreword"), _c('span', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("The past few years have seen some of the worst environmental disasters in history, signaling a new era of accelerating environmental destabilization. Food security and the strength of our global systems to meet basic human needs are under threat and have already caused irreparable damage in the Global South. As our levels of consumption increase, so do the demands for fossil fuels and cheap labor. This is wholly unsustainable, and without systemic change, we cannot turn the tide on environmental"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("de"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("struction.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("All that said, there has been a fundamental shift in the perception of how the climate and waste crises are being handled. And with the advanced scrutiny coming from creators like Gittemarie, young activists living on the frontlines of climate change, and organizations, there is hope for o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ur")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("future.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("Many have argued that individual action cannot save the planet, but to the contrary, many individuals have galvanized the world into action. However, we mustn’t look to one person to motivate us, to see the enormity of the problem we are facing. Instead, we should individually do our parts and come together to create an even grea"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ter")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("Individual action plants a seed of hope in every single person who makes one swap, one lifestyle change, or reads one book outside their comfort zone. It is this action that helps to shift our mindset from overconsumption to mindful consumption, from buying the latest and greatest to choosing second-hand and vintage. While our one swap at a time may not immediately change the world, those around us will see our actions and may make one swap of "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("their")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("own.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("When you get thousands if not millions of individuals looking inward at their own actions, you get thousands of potential comrades with which to join forces. That self-scrutiny paves the way to create curious minds in all of us. If I want to stop consuming so many vegetables in plastic packaging, I may think about where I could shop to do so. After a time, I may consider how the shops themselves could make consumers’ lives easier by offering unpackaged foods. Eventually, this may lead me to ask, “Why is so much plastic packaging used and how could policy affect the whole country’s level of consumption?” And then, it may lead to collective action, to protest, to petition, to actual system"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ic")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("change.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body"
  }, [_vm._v("Gittemarie is particularly well-qualified, personally and professionally, to contribute to this conversation, and many of us who have followed her for years have learned a tremendous amount. One aspect of her work that is much needed is her in-depth video content that interrogates the validity of many sustainable claims. As an individual it is often difficult to decipher what is and isn’t greenwashing. Many brands seeking to offer consumers a more sustainable option often use buzzwords that actually lead to more confusion. I have no doubt that you will gain the tools needed to live more sustainably at the end of this book, and hopefully, it will motivate you to join forces and be a part of a collective for a more sustainab"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("le")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("future.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body ParaOverride-7"
  }, [_c('span', {
    staticClass: "Bold CharOverride-10"
  }, [_vm._v("Imogen “I")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold CharOverride-10"
  }, [_vm._v("mmy” Lucas")])]), _c('span', {
    staticClass: "Bold CharOverride-10"
  }, [_c('br')]), _vm._v("Sustainablility/low-impact bl"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ogger and ")]), _c('br'), _vm._v("influencer (@sustaina"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("bly_vegan)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0388c16b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SustainableBadass-5.vue
// module id = 75
// module chunks = 0